import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";

const PipeCrosssectionIcon: FunctionComponent = () => <MaterialUiIcons.Adjust />;

export default PipeCrosssectionIcon;
